import YapWebSocketClient from './yapWebSocketClient';

export default class YapHolderWebSocketClient extends YapWebSocketClient {
    constructor(assetId, createNew = false, options) {
        super(assetId, createNew, options, 'YapHolderWebSocketClient');
    }
}
